import React from 'react'
import { Box, Grid, Typography, Button, Switch, FormControlLabel } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import enquiry from '../../images/enquiry.png'
import estimate from '../../images/estimate.jpg'
import invoice from '../../images/invoice.jpg'
import service from '../../images/service.png'
import cashjob from '../../images/cashjob.jpg'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';




function Dashboard() {
    const navigate = useNavigate()
    const pageChange = (e) => { navigate('/Jobcard_Chart')};
    
  return (
    <Box  mt={2}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                {" "}
                Dash Board{" "}
              </Typography>
              </Grid>
              <Grid item xs={6}>
                <Box>
                    <Box display='flex' justifyContent='flex-end'>
                        <span >Home</span>
                        <FormControlLabel sx={{ marginLeft: '20px' }} control={<Switch size='small'color="success" />}  onChange={pageChange} />
                        <span >Tabular</span>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={2.4}>
              <Card sx={{ maxWidth: 345}}>
                <CardMedia
                  component="img"
                  height="250"
                  src={enquiry} alt='enquiry'
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    5
                  </Typography>
                  <Typography variant="body2" color="text.secondary" fontWeight= 'bold'>
                    ENQUIRY
                    <Button size="small" onClick={() => navigate('/enquiry')}> <ArrowForwardIcon sx={{ mr: "10px", fontSize: "25px", color:'black' }}></ArrowForwardIcon> </Button>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={2.4}>
              <Card sx={{ maxWidth: 345}}>
                <CardMedia
                  component="img"
                  height="250"
                  src={estimate} alt='estimate'
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    5
                  </Typography>
                  <Typography variant="body2" color="text.secondary" fontWeight= 'bold'>
                    ESTIMATE
                    <Button size="small" onClick={() => navigate('/estimate')}> <ArrowForwardIcon sx={{ mr: "10px", fontSize: "25px", color:'black' }}></ArrowForwardIcon> </Button>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={2.4}>
              <Card sx={{ maxWidth: 345}}>
                <CardMedia
                  component="img"
                  height="250"
                  src={invoice} alt='invoice'
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    5
                  </Typography>
                  <Typography variant="body2" color="text.secondary" fontWeight= 'bold'>
                    INVOICE
                    <Button size="small" onClick={() => navigate('/Invoice')}> <ArrowForwardIcon sx={{ mr: "10px", fontSize: "25px", color:'black' }}></ArrowForwardIcon> </Button>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={2.4}>
              <Card sx={{ maxWidth: 345 }}>
                <CardMedia
                  component="img"
                  height="250"
                  src={service} alt='service'
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    5
                  </Typography>
                  <Typography variant="body2" color="text.secondary" fontWeight= 'bold'>
                    SERVICE
                    <Button size="small" onClick={() => navigate('/service_Order')}> <ArrowForwardIcon sx={{ mr: "10px", fontSize: "25px", color:'black' }}></ArrowForwardIcon> </Button>
                  </Typography>
                </CardContent>
              </Card>
              </Grid>
              <Grid item xs={2.4}>
              <Card sx={{ maxWidth: 345}}>
                <CardMedia
                  component="img"
                  height="250"
                  src={cashjob} alt='cashjob'
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    5
                  </Typography>
                  <Typography variant="body2" color="text.secondary" fontWeight= 'bold'>
                    CASH JOB
                    <Button size="small" onClick={() => navigate('/Cash_Job')}> <ArrowForwardIcon sx={{ mr: "10px", fontSize: "25px", color:'black' }}></ArrowForwardIcon> </Button>
                  </Typography>
                </CardContent>
              </Card>
              </Grid>
              <Grid item xs={2.4}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardContent>
                    <Typography variant="body2" color="text.secondary" fontWeight= 'bold'>
                      DASH BOARD
                      <Button size="small" onClick={() => navigate('/Dashboard')}> <ArrowForwardIcon sx={{ mr: "10px", fontSize: "25px", color:'black' }}></ArrowForwardIcon> </Button>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={2.4}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardContent>
                    <Typography variant="body2" color="text.secondary" fontWeight= 'bold'>
                     MASTER FILE
                      <Button size="small" onClick={() => navigate('/Master')}> <ArrowForwardIcon sx={{ mr: "10px", fontSize: "25px", color:'black' }}></ArrowForwardIcon> </Button>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={2.4}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardContent>
                    <Typography variant="body2" color="text.secondary" fontWeight= 'bold'>
                      REPORT
                      <Button size="small" onClick={() => navigate('/Report')}> <ArrowForwardIcon sx={{ mr: "10px", fontSize: "25px", color:'black' }}></ArrowForwardIcon> </Button>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={2.4}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardContent>
                    <Typography variant="body2" color="text.secondary" fontWeight= 'bold'>
                      SETTINGS
                      <Button size="small" onClick={() => navigate('/Settings')}> <ArrowForwardIcon sx={{ mr: "10px", fontSize: "25px", color:'black' }}></ArrowForwardIcon> </Button>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

          </Grid>
        </Grid>

        <Grid item xs={12} mt={1}></Grid>
      </Grid>
    </Box>
  );
}
export default Dashboard